/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DoesVarenrExistsResponseDto as OkEgisServiceG4CommunicationDtoDoesVarenrExistsResponseDto } from '../models/OK/Egis/Service/G4Communication/DTO/does-varenr-exists-response-dto';
import { PartnerVarenrMappingDto as OkEgisServiceModelsDtoPartnerVarenrMappingDto } from '../models/OK/Egis/Service/Models/DTO/partner-varenr-mapping-dto';

@Injectable({
  providedIn: 'root',
})
export class VareService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation doesVareNrExist
   */
  static readonly DoesVareNrExistPath = '/api/v1/Vare/DoesVareNrExist';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doesVareNrExist()` instead.
   *
   * This method doesn't expect any request body.
   */
  doesVareNrExist$Response(params: {
    vareNr?: number;
    leveringsDato?: string;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceG4CommunicationDtoDoesVarenrExistsResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, VareService.DoesVareNrExistPath, 'get');
    if (params) {
      rb.query('vareNr', params.vareNr, {});
      rb.query('leveringsDato', params.leveringsDato, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceG4CommunicationDtoDoesVarenrExistsResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `doesVareNrExist$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doesVareNrExist(params: {
    vareNr?: number;
    leveringsDato?: string;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceG4CommunicationDtoDoesVarenrExistsResponseDto> {

    return this.doesVareNrExist$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceG4CommunicationDtoDoesVarenrExistsResponseDto>) => r.body as OkEgisServiceG4CommunicationDtoDoesVarenrExistsResponseDto)
    );
  }

  /**
   * Path part for operation getAllPartnerVareNrMappings
   */
  static readonly GetAllPartnerVareNrMappingsPath = '/api/v1/Vare/GetAllPartnerVareNrMappings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllPartnerVareNrMappings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllPartnerVareNrMappings$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoPartnerVarenrMappingDto>>> {

    const rb = new RequestBuilder(this.rootUrl, VareService.GetAllPartnerVareNrMappingsPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoPartnerVarenrMappingDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllPartnerVareNrMappings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllPartnerVareNrMappings(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoPartnerVarenrMappingDto>> {

    return this.getAllPartnerVareNrMappings$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoPartnerVarenrMappingDto>>) => r.body as Array<OkEgisServiceModelsDtoPartnerVarenrMappingDto>)
    );
  }

  /**
   * Path part for operation createPartnerVareNrMapping
   */
  static readonly CreatePartnerVareNrMappingPath = '/api/v1/Vare/CreatePartnerVareNrMapping';

  /**
   * Creates a PartnerVarenrMapping.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPartnerVareNrMapping()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPartnerVareNrMapping$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoPartnerVarenrMappingDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoPartnerVarenrMappingDto>> {

    const rb = new RequestBuilder(this.rootUrl, VareService.CreatePartnerVareNrMappingPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoPartnerVarenrMappingDto>;
      })
    );
  }

  /**
   * Creates a PartnerVarenrMapping.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createPartnerVareNrMapping$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPartnerVareNrMapping(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoPartnerVarenrMappingDto
  }): Observable<OkEgisServiceModelsDtoPartnerVarenrMappingDto> {

    return this.createPartnerVareNrMapping$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoPartnerVarenrMappingDto>) => r.body as OkEgisServiceModelsDtoPartnerVarenrMappingDto)
    );
  }

  /**
   * Path part for operation updatePartnerVareNrMapping
   */
  static readonly UpdatePartnerVareNrMappingPath = '/api/v1/Vare/UpdatePartnerVareNrMapping';

  /**
   * Updates a PartnerVarenrMapping.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePartnerVareNrMapping()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePartnerVareNrMapping$Response(params: {
    id?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoPartnerVarenrMappingDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoPartnerVarenrMappingDto>> {

    const rb = new RequestBuilder(this.rootUrl, VareService.UpdatePartnerVareNrMappingPath, 'put');
    if (params) {
      rb.query('id', params.id, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoPartnerVarenrMappingDto>;
      })
    );
  }

  /**
   * Updates a PartnerVarenrMapping.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updatePartnerVareNrMapping$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePartnerVareNrMapping(params: {
    id?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoPartnerVarenrMappingDto
  }): Observable<OkEgisServiceModelsDtoPartnerVarenrMappingDto> {

    return this.updatePartnerVareNrMapping$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoPartnerVarenrMappingDto>) => r.body as OkEgisServiceModelsDtoPartnerVarenrMappingDto)
    );
  }

  /**
   * Path part for operation deletePartnerVareNrMapping
   */
  static readonly DeletePartnerVareNrMappingPath = '/api/v1/Vare/DeletePartnerVareNrMapping';

  /**
   * Deletes a PartnerVarenrMapping.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletePartnerVareNrMapping()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePartnerVareNrMapping$Response(params: {
    id?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoPartnerVarenrMappingDto>> {

    const rb = new RequestBuilder(this.rootUrl, VareService.DeletePartnerVareNrMappingPath, 'delete');
    if (params) {
      rb.query('id', params.id, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoPartnerVarenrMappingDto>;
      })
    );
  }

  /**
   * Deletes a PartnerVarenrMapping.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deletePartnerVareNrMapping$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePartnerVareNrMapping(params: {
    id?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoPartnerVarenrMappingDto> {

    return this.deletePartnerVareNrMapping$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoPartnerVarenrMappingDto>) => r.body as OkEgisServiceModelsDtoPartnerVarenrMappingDto)
    );
  }

}
